import { inboundProcessApi } from "src/api/inbound-process";
import { paths } from "src/paths";
import { slice } from "src/slices/inbound-process";
import { useSelector } from "src/store";
import toast from "react-hot-toast";
import { Stack } from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";

const verifyPurchaseOrderHash = (purchaseOrderHash) => async (dispatch) => {
  try {
    dispatch(slice.actions.setPOVerificationLoading(true));

    const response = await inboundProcessApi
      .verifyPurchaseOrderHash(purchaseOrderHash)
      .catch(() => {
        dispatch(slice.actions.setPOIsValid(false));
        dispatch(slice.actions.setPOVerificationLoading(false));
        dispatch(slice.actions.setVerifiedPO(true));
      });

    dispatch(slice.actions.setPOIsValid(response.POIsValid));
    dispatch(slice.actions.setDocumentNumber(response.documentNumber));
    dispatch(slice.actions.setPOVerificationLoading(false));
    dispatch(slice.actions.setVerifiedPO(true));
  } catch (err) {
    console.log(err);
  }
};

const getPurchaseOrder = (po_id) => async (dispatch) => {
  try {
    const response = await inboundProcessApi.getPurchaseOrder(po_id);

    dispatch(slice.actions.setPurchaseOrder(response));
  } catch (err) {
    console.log(err);
  }
};

const getPurchaseOrders = () => async (dispatch) => {
  try {
    const response = await inboundProcessApi.getPurchaseOrders();

    dispatch(slice.actions.setPurchaseOrders(response));
  } catch (err) {
    console.log(err);
  }
};

const getPurchaseOrdersBrand = () => async (dispatch) => {
  try {
    const response = await inboundProcessApi.getPurchaseOrdersBrand();

    dispatch(slice.actions.setPurchaseOrders(response));
  } catch (err) {
    console.log(err);
  }
};

const getPurchaseOrdersSupplier = () => async (dispatch) => {
  try {
    const response = await inboundProcessApi.getPurchaseOrdersSupplier();

    dispatch(slice.actions.setPurchaseOrders(response));
  } catch (err) {
    console.log(err);
  }
};

const getPOItems = (purchaseOrderHash) => async (dispatch) => {
  try {
    dispatch(slice.actions.setPOItemsLoading(true));

    const response = await inboundProcessApi
      .getPOItems(purchaseOrderHash)
      .catch(() => {
        dispatch(slice.actions.setPOItems(false));
        dispatch(slice.actions.setPOItemsLoading(false));
      });

    dispatch(slice.actions.setPOItems(response));
    dispatch(slice.actions.setPOItemsLoading(false));
  } catch (err) {
    console.log(err);
  }
};

const getInboundRequest = (inboundRequestId) => async (dispatch) => {
  try {
    dispatch(slice.actions.setInboundRequestLoading(true));

    const response =
      await inboundProcessApi.getInboundRequest(inboundRequestId);

    dispatch(slice.actions.setInboundRequest(response));
    dispatch(slice.actions.setInboundRequestLoading(false));
  } catch (err) {
    dispatch(slice.actions.setInboundRequestLoading(false));
    console.log(err);
  }
};

const getInboundRequestQuantities =
  (inboundRequestId, itemQuantities, inboundRequest, selectedPOItems) =>
  async (dispatch) => {
    try {
      dispatch(slice.actions.setInboundRequestLoading(true));

      const calculatedNetTotal =
        await inboundProcessApi.getInboundRequestQuantities(
          inboundRequestId,
          itemQuantities,
        );

      dispatch(
        slice.actions.setInboundRequest({
          ...inboundRequest,
          // purchase_order_items: selectedPOItems,
          calculatedNetTotal,
        }),
      );
      dispatch(slice.actions.setInboundRequestLoading(false));
    } catch (err) {
      dispatch(
        slice.actions.setInboundRequest({
          ...inboundRequest,
        }),
      );
      dispatch(slice.actions.setInboundRequestLoading(false));
      console.log(err);
    }
  };

const getInboundRequests = () => async (dispatch) => {
  try {
    dispatch(slice.actions.setInboundRequestsLoading(true));

    const response = await inboundProcessApi.getInboundRequests();

    dispatch(slice.actions.setInboundRequests(response));
    dispatch(slice.actions.setInboundRequestsLoading(false));
  } catch (err) {
    console.log(err);
    dispatch(slice.actions.setInboundRequestsLoading(false));
  }
};

const getInboundASNs = () => async (dispatch) => {
  try {
    const response = await inboundProcessApi.getInboundASNs();

    dispatch(slice.actions.setInboundRequests(response));
  } catch (err) {
    console.log(err);
  }
};

const getInboundRequestsOfBrand = (brandName) => async (dispatch) => {
  try {
    const response =
      await inboundProcessApi.getInboundRequestsOfBrand(brandName);

    dispatch(slice.actions.setInboundRequests(response));
  } catch (err) {
    console.log(err);
  }
};

const getInboundASNsOfBrand = (brandName) => async (dispatch) => {
  try {
    const response = await inboundProcessApi.getInboundASNsOfBrand(brandName);

    dispatch(slice.actions.setInboundRequests(response));
  } catch (err) {
    console.log(err);
  }
};

const getInboundRequestsOfSupplier = (supplierId) => async (dispatch) => {
  try {
    const response =
      await inboundProcessApi.getInboundRequestsOfSupplier(supplierId);

    dispatch(slice.actions.setInboundRequests(response));
  } catch (err) {
    console.log(err);
  }
};

const getInboundASNsOfSupplier = (supplierId) => async (dispatch) => {
  try {
    const response =
      await inboundProcessApi.getInboundASNsOfSupplier(supplierId);

    dispatch(slice.actions.setInboundRequests(response));
  } catch (err) {
    console.log(err);
  }
};

const getInboundRequestsItemsQuantityOfPO = (brandName) => async (dispatch) => {
  try {
    const response =
      await inboundProcessApi.getInboundRequestsItemsQuantityOfPO(brandName);

    dispatch(slice.actions.setInboundRequestsItemsQuantityOfPO(response));
  } catch (err) {
    console.log(err);
  }
};

const createInboundRequest = (formData, handleClose) => async (dispatch) => {
  try {
    dispatch(slice.actions.setSubmitInboundRequestError(false));
    dispatch(slice.actions.setSubmitCurrencyError(false));
    dispatch(slice.actions.setSubmitInboundRequestLoading(true));

    await inboundProcessApi.createInboundRequest(formData);

    dispatch(slice.actions.setSubmitInboundRequestLoading(false));
    window.location.href = paths.dashboard.inbound.requests.index;
    handleClose();
  } catch (err) {
    dispatch(slice.actions.setSubmitInboundRequestLoading(false));
    toast(
      <div>
        <Stack>Error while creating Inbound Request</Stack>
      </div>,
      {
        duration: 5000,
        style: {
          fontFamily: "tmwCustomFont",
          letterSpacing: 1,
          fontSize: 12,
          backgroundColor: "white",
          color: "black",
          border: "1px solid #E6E6E6",
        },
      },
    );

    await inboundProcessApi
      .addHistoryRecord(
        formData.id,
        "Error",
        "Error while creating Inbound Request",
      )
      .catch(() => {});

    if (err.response.data.error.message === "currency_value_mismatch") {
      dispatch(slice.actions.setSubmitCurrencyError(true));
    } else {
      dispatch(slice.actions.setSubmitInboundRequestError(true));
    }
  }
};

const editInboundRequest = (formData) => async (dispatch) => {
  try {
    dispatch(slice.actions.setSubmitInboundRequestError(false));
    dispatch(slice.actions.setSaveChangesLoading(true));

    await inboundProcessApi.editInboundRequest(formData);

    dispatch(slice.actions.setSaveChangesLoading(false));
    toast.success("Changes saved", {
      style: {
        width: "max-content",
        maxWidth: "90vw",
        minWidth: "unset",
      },
    });
  } catch (err) {
    console.log(err);
    dispatch(slice.actions.setSubmitInboundRequestError(true));
    dispatch(slice.actions.setSaveChangesLoading(false));
    toast(
      <div>
        <Stack>The changes could not be saved.</Stack>
        <Stack>Please try again or contact the Tomorrow Portal team.</Stack>
      </div>,
      {
        duration: 5000,
        style: {
          fontFamily: "tmwCustomFont",
          letterSpacing: 1,
          fontSize: 12,
          backgroundColor: "white",
          color: "black",
          border: "1px solid #E6E6E6",
        },
      },
    );
    await inboundProcessApi.addHistoryRecord(
      formData.id,
      "Error",
      "The changes could not be saved",
    );
  }
};

const confirmExtraUnitsReceived =
  (inboundRequestId, extraUnitsItems = []) =>
  async () => {
    try {
      await inboundProcessApi.confirmExtraUnitsReceived(
        inboundRequestId,
        extraUnitsItems,
      );
    } catch (err) {
      console.log(err);
    }
  };

const confirmMissingItemsChoice =
  (
    inboundRequestId,
    uploadCNForMissingItems,
    shipMissingItems,
    missingItemsCreditNoteFile = null,
  ) =>
  async () => {
    try {
      await inboundProcessApi.confirmMissingItemsChoice(
        inboundRequestId,
        uploadCNForMissingItems,
        shipMissingItems,
        missingItemsCreditNoteFile,
      );
    } catch (err) {
      console.log(err);
      throw err;
    }
  };

const saveCreditNote = (inboundRequestId, creditNoteFile) => async () => {
  try {
    await inboundProcessApi.saveCreditNote(inboundRequestId, creditNoteFile);
  } catch (err) {
    console.log(err);
    throw err;
  }
};

const submitInboundRequest =
  (id, skipPending = false) =>
  async (dispatch) => {
    try {
      dispatch(slice.actions.setInboundRequestStatusChangeSubmitLoading(true));

      await inboundProcessApi.submitInboundRequest(id, skipPending);

      dispatch(slice.actions.setInboundRequestStatusChangeSubmitLoading(false));

      window.location.href = paths.dashboard.inbound.requests.index;
    } catch (err) {
      dispatch(slice.actions.setInboundRequestStatusChangeSubmitLoading(false));
      toast(
        <div>
          <Stack>Error while confirming Inbound Request</Stack>
          <Stack flexDirection="row" alignItems="center" marginTop={1}>
            <div
              style={{
                marginRight: 3,
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                border: `1.5px solid orange`,
                background: "orange",
                display: "inline-block",
              }}
            />
            Draft
          </Stack>
        </div>,
        {
          duration: 5000,
          style: {
            fontFamily: "tmwCustomFont",
            letterSpacing: 1,
            fontSize: 12,
            backgroundColor: "white",
            color: "black",
            border: "1px solid #E6E6E6",
          },
        },
      );

      await inboundProcessApi.addHistoryRecord(
        id,
        "Error",
        "Error while submitting Inbound Request",
      );

      if (err.response.data.error.message === "currency_value_mismatch") {
        dispatch(slice.actions.setSubmitCurrencyError(true));
      } else {
        dispatch(slice.actions.setSubmitInboundRequestError(true));
      }
    }
  };

const draftInboundRequest = (formData) => async (dispatch) => {
  try {
    dispatch(slice.actions.setInboundRequestStatusChangeDraftLoading(true));

    await inboundProcessApi.draftInboundRequest(formData);

    dispatch(slice.actions.setInboundRequestStatusChangeDraftLoading(false));
    window.location.href = paths.dashboard.inbound.requests.index;
  } catch (err) {
    console.log(err);
  }
};

const setToPendingInboundRequest = (formData) => async (dispatch) => {
  try {
    dispatch(slice.actions.setInboundRequestStatusChangePendingLoading(true));

    await inboundProcessApi.setToPendingInboundRequest(formData);

    dispatch(slice.actions.setInboundRequestStatusChangePendingLoading(false));
    window.location.href = paths.dashboard.inbound.requests.index;
  } catch (err) {
    dispatch(slice.actions.setInboundRequestStatusChangePendingLoading(false));
    console.log(err);
  }
};

const approveInboundRequest =
  (
    id,
    incoterm,
    inbshipRequestDate,
    expectedDeliveryDate,
    approvalMemo,
    POItemsToUpdate,
    POItemsHistory,
  ) =>
  async (dispatch) => {
    try {
      dispatch(slice.actions.setInboundRequestStatusChangeApproveLoading(true));

      await inboundProcessApi.approveInboundRequest(
        id,
        incoterm,
        inbshipRequestDate,
        expectedDeliveryDate,
        approvalMemo,
        POItemsToUpdate,
        POItemsHistory,
      );

      dispatch(
        slice.actions.setInboundRequestStatusChangeApproveLoading(false),
      );
      window.location.href = paths.dashboard.inbound.requests.index;
    } catch (err) {
      toast(
        (t) => (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                gap: 10,
              }}
            >
              <div>
                <Stack>
                  The NetSuite synchronization of the Inbound Request
                  encountered an error:
                </Stack>
                <Stack style={{ fontWeight: 600, margin: "10px 0" }}>
                  {err?.response?.data?.message ||
                    err?.response?.data?.error?.message}
                </Stack>
                <Stack>The Inbound Request is still Pending.</Stack>
                <Stack>
                  Please try again or contact the Tomorrow Portal team.
                </Stack>
                <Stack flexDirection="row" alignItems="center" marginTop={1}>
                  <div
                    style={{
                      marginRight: 3,
                      width: "10px",
                      height: "10px",
                      borderRadius: "50%",
                      border: `1.5px solid red`,
                      background: "red",
                      display: "inline-block",
                    }}
                  />
                  Pending
                </Stack>
              </div>
              <button
                onClick={() => toast.dismiss(t.id)}
                style={{
                  border: "none",
                  background: "transparent",
                  cursor: "pointer",
                  fontSize: 10,
                  lineHeight: 1,
                  padding: 4,
                  color: "#333",
                }}
                aria-label="Close"
                title="Close"
              >
                <CloseOutlined />
              </button>
            </div>
          </div>
        ),
        {
          duration: Infinity,
          style: {
            fontFamily: "tmwCustomFont",
            letterSpacing: 1,
            fontSize: 12,
            backgroundColor: "white",
            color: "black",
            border: "1px solid #E6E6E6",
            width: "fit-content",
            maxWidth: "90vw",
          },
        },
      );
      await inboundProcessApi.addHistoryRecord(
        id,
        "Error",
        `The NetSuite synchronization of the Inbound Request encountered an error: ${
          err?.response?.data?.message || err?.response?.data?.error?.message
        }`,
      );
      dispatch(
        slice.actions.setInboundRequestStatusChangeApproveLoading(false),
      );
      dispatch(thunks.getInboundRequest(id));
    }
  };

const authorizeInboundRequest = (id) => async (dispatch) => {
  try {
    dispatch(slice.actions.setInboundRequestStatusChangeApproveLoading(true));

    await inboundProcessApi.authorizeInboundRequest(id);

    dispatch(slice.actions.setInboundRequestStatusChangeApproveLoading(false));
    window.location.href = paths.dashboard.inbound.requests.index;
  } catch (err) {
    toast(
      (t) => (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              gap: 10,
            }}
          >
            <div>
              <Stack>Error while authorizing the Inbound Request:</Stack>
              <Stack style={{ fontWeight: 600, margin: "10px 0" }}>
                {err.response?.data?.message || "Unknown error"}
              </Stack>
              <Stack>The Inbound Request is still Pending.</Stack>
            </div>
            <button
              onClick={() => toast.dismiss(t.id)}
              style={{
                border: "none",
                background: "transparent",
                cursor: "pointer",
                fontSize: 10,
                lineHeight: 1,
                padding: 4,
                color: "#333",
              }}
              aria-label="Close"
              title="Close"
            >
              <CloseOutlined />
            </button>
          </div>
        </div>
      ),
      {
        duration: Infinity,
        style: {
          fontFamily: "tmwCustomFont",
          letterSpacing: 1,
          fontSize: 12,
          backgroundColor: "white",
          color: "black",
          border: "1px solid #E6E6E6",
          width: "fit-content",
          maxWidth: "90vw",
        },
      },
    );
    await inboundProcessApi.addHistoryRecord(
      id,
      "Error",
      `Error while authorizing the Inbound Request: ${
        err.response?.data?.message || "Unknown error"
      }`,
    );
    dispatch(slice.actions.setInboundRequestStatusChangeApproveLoading(false));
    dispatch(thunks.getInboundRequest(id));
  }
};

const closeInboundRequest = (inboundRequestId) => async () => {
  try {
    await inboundProcessApi.closeInboundRequest(inboundRequestId);
  } catch (err) {
    console.log(err);
    throw err;
  }
};

const markInboundRequestAsReceived = (inboundRequestId) => async () => {
  try {
    await inboundProcessApi.markInboundRequestAsReceived(inboundRequestId);
  } catch (err) {
    console.log(err);
    throw err;
  }
};

const notifyChangeRequest = (inboundRequestId, note) => async () => {
  try {
    await inboundProcessApi.notifyChangeRequest(inboundRequestId, note);
  } catch (err) {
    console.log(err);
    throw err;
  }
};

const submitPickUpDetails = (formData) => async (dispatch) => {
  try {
    await inboundProcessApi.submitPickUpDetails(formData);

    window.location.href = paths.dashboard.inbound.requests.index;
  } catch (err) {
    console.log(err);
  }
};

const approvePickupDetails = (id) => async (dispatch) => {
  try {
    dispatch(slice.actions.setInboundRequestStatusChangeApproveLoading(true));

    await inboundProcessApi.approvePickupDetails(id);

    dispatch(slice.actions.setInboundRequestStatusChangeApproveLoading(false));
    window.location.href = paths.dashboard.inbound.requests.index;
  } catch (err) {
    toast(
      (t) => (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              gap: 10,
            }}
          >
            <div>
              <Stack>Error while approving the pickup details:</Stack>
              <Stack style={{ fontWeight: 600, margin: "10px 0" }}>
                {err.response?.data?.message || err.message || "Unknown error"}
              </Stack>
            </div>
            <button
              onClick={() => toast.dismiss(t.id)}
              style={{
                border: "none",
                background: "transparent",
                cursor: "pointer",
                fontSize: 10,
                lineHeight: 1,
                padding: 4,
                color: "#333",
              }}
              aria-label="Close"
              title="Close"
            >
              <CloseOutlined />
            </button>
          </div>
        </div>
      ),
      {
        duration: Infinity,
        style: {
          fontFamily: "tmwCustomFont",
          letterSpacing: 1,
          fontSize: 12,
          backgroundColor: "white",
          color: "black",
          border: "1px solid #E6E6E6",
          width: "fit-content",
          maxWidth: "90vw",
        },
      },
    );
    await inboundProcessApi.addHistoryRecord(
      id,
      "Error",
      `Error while approving the pickup details: ${
        err.response?.data?.message || err.message || "Unknown error"
      }`,
    );
    dispatch(slice.actions.setInboundRequestStatusChangeApproveLoading(false));
  }
};

const addHistoryRecord = (id, type, message) => async (dispatch) => {
  try {
    await inboundProcessApi.addHistoryRecord(id, type, message);
  } catch (err) {
    console.log(err);
  }
};

const getIncotermField = (id) => async (dispatch) => {
  try {
    dispatch(slice.actions.setIncotermFieldLoading(true));

    const incoterm = await inboundProcessApi.getIncotermField(id);

    dispatch(slice.actions.setIncotermField(incoterm));
    dispatch(slice.actions.setIncotermFieldLoading(false));
  } catch (err) {
    console.log(err);
    window.location.href = paths.dashboard.inbound.requests.index;
  }
};

const saveChangesAddInboundRequest = (formData) => async (dispatch) => {
  try {
    dispatch(slice.actions.setSaveChangesLoading(true));

    const inboundRequestId =
      await inboundProcessApi.saveChangesAddInboundRequest(formData);

    dispatch(slice.actions.setSaveChangesLoading(false));
    toast.success("Changes saved", {
      style: {
        width: "max-content",
        maxWidth: "90vw",
        minWidth: "unset",
      },
    });

    setTimeout(() => {
      window.location.href =
        paths.dashboard.inbound.requests.edit + inboundRequestId;
    }, 1000); // 1.5 second delay to show toast
  } catch (err) {
    console.log(err);
    toast.error("Failed to save changes");
  }
};

const addInboundRequestNote = (formData) => async (dispatch) => {
  try {
    await inboundProcessApi.addInboundRequestNote(formData);
  } catch (err) {
    console.log(err);
    throw err;
  }
};

const editInboundRequestNote = (formData) => async (dispatch) => {
  try {
    await inboundProcessApi.editInboundRequestNote(formData);
  } catch (err) {
    console.log(err);
    throw err;
  }
};

const deleteInboundRequestNote =
  (inboundRequestId, noteId) => async (dispatch) => {
    try {
      await inboundProcessApi.deleteInboundRequestNote(
        inboundRequestId,
        noteId,
      );
    } catch (err) {
      console.log(err);
      throw err;
    }
  };

const getBrandTolerances = () => async (dispatch) => {
  try {
    dispatch(slice.actions.setBrandTolerancesLoading(true));
    const response = await inboundProcessApi.getBrandTolerances();

    dispatch(slice.actions.setBrandTolerances(response));
    dispatch(slice.actions.setBrandTolerancesLoading(false));
  } catch (err) {
    dispatch(slice.actions.setBrandTolerancesLoading(false));
    console.log(err);
    throw err;
  }
};

const updateBrandTolerances = (formData) => async (dispatch) => {
  try {
    const response = await inboundProcessApi.updateBrandTolerances(formData);
    toast.success(response);
  } catch (err) {
    console.log(err.response.data.error.message);
    toast.error(err.response.data.error.message);
    throw err;
  }
};

const getPickupAutocompleteData = (inboundRequestId) => async (dispatch) => {
  try {
    dispatch(slice.actions.setPickupAutocompleteDataLoading(true));

    const response =
      await inboundProcessApi.getPickupAutocompleteData(inboundRequestId);

    dispatch(slice.actions.setPickupAutocompleteData(response));
    dispatch(slice.actions.setPickupAutocompleteDataLoading(false));
  } catch (err) {
    dispatch(slice.actions.setPickupAutocompleteDataLoading(false));
    console.log(err);
  }
};

const getSupplierAddresses = () => async (dispatch) => {
  try {
    dispatch(slice.actions.setSupplierAddressesLoading(true));
    dispatch(slice.actions.setSupplierAddresses(null));

    const response = await inboundProcessApi.getSupplierAddresses();

    dispatch(slice.actions.setSupplierAddressesLoading(false));
    dispatch(slice.actions.setSupplierAddresses(response));
  } catch (err) {
    dispatch(slice.actions.setSupplierAddressesLoading(false));
    dispatch(slice.actions.setSupplierAddresses(null));
    console.log(err);
  }
};

const getSupplierAddressesByPurchaseOrder =
  (purchaseOrderId) => async (dispatch) => {
    try {
      dispatch(slice.actions.setSupplierAddressesLoading(true));
      dispatch(slice.actions.setSupplierAddresses(null));

      const response =
        await inboundProcessApi.getSupplierAddressesByPurchaseOrder(
          purchaseOrderId,
        );

      dispatch(slice.actions.setSupplierAddressesLoading(false));
      dispatch(slice.actions.setSupplierAddresses(response));
    } catch (err) {
      dispatch(slice.actions.setSupplierAddressesLoading(false));
      dispatch(slice.actions.setSupplierAddresses(null));
      console.log(err);
    }
  };

const getInboundRequestEmailHistory =
  (inboundRequestId) => async (dispatch) => {
    try {
      const response =
        await inboundProcessApi.getInboundRequestEmailHistory(inboundRequestId);
      dispatch(slice.actions.setInboundRequestEmailHistory(response));
    } catch (err) {
      console.log(err);
    }
  };

export const thunks = {
  verifyPurchaseOrderHash,
  getPurchaseOrder,
  getPurchaseOrders,
  getPurchaseOrdersBrand,
  getPurchaseOrdersSupplier,
  getPOItems,
  getInboundRequest,
  getInboundRequestQuantities,
  getInboundRequests,
  getInboundASNs,
  getInboundRequestsOfBrand,
  getInboundASNsOfBrand,
  getInboundRequestsOfSupplier,
  getInboundASNsOfSupplier,
  getInboundRequestsItemsQuantityOfPO,
  createInboundRequest,
  editInboundRequest,
  confirmExtraUnitsReceived,
  confirmMissingItemsChoice,
  saveCreditNote,
  submitInboundRequest,
  draftInboundRequest,
  setToPendingInboundRequest,
  approveInboundRequest,
  authorizeInboundRequest,
  closeInboundRequest,
  markInboundRequestAsReceived,
  notifyChangeRequest,
  submitPickUpDetails,
  approvePickupDetails,
  addHistoryRecord,
  getIncotermField,
  saveChangesAddInboundRequest,
  addInboundRequestNote,
  editInboundRequestNote,
  deleteInboundRequestNote,
  getBrandTolerances,
  updateBrandTolerances,
  getPickupAutocompleteData,
  getSupplierAddresses,
  getSupplierAddressesByPurchaseOrder,
  getInboundRequestEmailHistory,
};
